/* eslint-disable no-alert */
import {Input, Text} from '@ui-kitten/components';
import React from 'react';
import {Image, StyleSheet, TouchableOpacity, View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {postCheckEmail, postSendCode} from '../../../apis';
import {starBanner} from '../../../assets/images';
import {UN_AUTHENTICATED_ROUTES} from '../../../navigation/constants';
import {isWebDesktopView, px, validateEmail, wp} from '../../../utils';
import {fieldUtils} from '../../../utils/fieldUtils';
import AppButton from '../../common/AppButton';
import {LoadingIndicator} from '../../components';
// import OtpModal from '../OtpModal';
import {postVerifyCode} from '../../../apis';

const initialFieldsErrors = {
  fullName: undefined,
  email: undefined,
  password1: undefined,
  password2: undefined,
};

const isWebDesktop = isWebDesktopView();

class SignUpScreen extends React.Component {
  state = {
    fullName: '',
    email: '',
    password1: '',
    password2: '',
    code: '',
    fieldError: '',
    fieldsErrors: {...initialFieldsErrors},
    canSignUpWithEmail: false,
    isCheckingEmail: false,
    isRequestingOTP: false,
    showOtpModal: false,
    loadingCheckOtp: false,
  };

  handleVerifyCode = async () => {
    let {email, code} = this.state;
    try {
      this.setState({loadingCheckOtp: true});
      await postVerifyCode({email, code});
      this.setState({loadingCheckOtp: false});
      this.handleGoToNextPage();
    } catch (error) {
      this.setState({fieldError: String(error), loadingCheckOtp: false});
    }
  };

  checkCode = () => {
    let {email, code} = this.state;
    // 6 digits
    if (!email) {
      const text = 'Please enter email id!';
      this.setState({fieldError: text});
      return;
    }
    if (!code.match(/^\d{6,6}$/)) {
      const text = 'Code should contain only numbers and should be 6 digits!';
      this.setState({fieldError: text});
      return;
    }

    this.handleVerifyCode();
  };

  handleCheckEmail = async () => {
    const {email} = this.state;
    let errorText;
    let canSignUpWithEmail = false;

    this.setState({isCheckingEmail: true});

    try {
      await postCheckEmail({email});
      canSignUpWithEmail = true;
    } catch (error) {
      errorText = 'Already an account exist for this email';
    }

    this.setState(({fieldsErrors}) => ({
      isCheckingEmail: false,
      canSignUpWithEmail,
      fieldsErrors: {
        ...fieldsErrors,
        email: errorText,
      },
    }));
  };

  onSignIn = () => {
    const {navigation} = this.props;
    navigation.push(UN_AUTHENTICATED_ROUTES.signIn.path);
  };

  onChange = (key, value) => {
    this.setState({[key]: value});
  };

  checkRequiredFieldsError = () => {
    const {fullName, email, password1, password2} = this.state;

    const errorText = 'This field should be filled out.';
    const errors = {};

    if (fullName === '') {
      errors.fullName = errorText;
    }

    if (email === '') {
      errors.email = errorText;
    }

    if (password1 === '') {
      errors.password1 = errorText;
    }

    if (password2 === '') {
      errors.password2 = errorText;
    }

    return errors;
  };

  checkPasswordsError = () => {
    // no whitespace and min 6 char
    const passRegex = /^\S{6,}$/;
    const errors = {};

    if (this.state.password1 === this.state.password2) {
      if (!this.state.password1.match(passRegex)) {
        const text =
          'Password should not contain space and should be min 6 characters!';
        errors.password1 = text;
        errors.password2 = text;
      }
    } else {
      const text = 'Both Password do not match!';
      errors.password1 = text;
      errors.password2 = text;
    }

    return errors;
  };

  checkTextOnlyErrors = () => {
    // only letters and space (\s)
    // const regex = /^[A-Za-z\s]+$/;
    // const errorText = 'You may use only letters for this Field.';
    const errors = {};

    // if (!regex.test(this.state.fullName)) {
    //   errors.fullName = errorText;
    // }

    return errors;
  };

  checkNumberOnlyErrors = () => {
    // const regex = /^\d+$/;
    // const errorText = 'You may use only numbers for this Field.';
    const errors = {};

    return errors;
  };

  checkEmailErrors = () => {
    const errors = {};

    if (!validateEmail(this.state.email)) {
      errors.email = 'Email format is not valid.';
    }

    return errors;
  };

  isFormValid = () => {
    const requiredErrors = this.checkRequiredFieldsError();
    if (Object.keys(requiredErrors).length) {
      this.setState({fieldsErrors: requiredErrors});
      return false;
    }

    const emailErrors = this.checkEmailErrors();
    if (Object.keys(emailErrors).length) {
      this.setState({fieldsErrors: emailErrors});
      return false;
    }

    const passwordErrors = this.checkPasswordsError();
    if (Object.keys(passwordErrors).length) {
      this.setState({fieldsErrors: passwordErrors});
      return false;
    }

    const onlyTextErrors = this.checkTextOnlyErrors();
    if (Object.keys(onlyTextErrors).length) {
      this.setState({fieldsErrors: onlyTextErrors});
      return false;
    }

    const onlyNumberErrors = this.checkNumberOnlyErrors();
    if (Object.keys(onlyNumberErrors).length) {
      this.setState({fieldsErrors: onlyNumberErrors});
      return false;
    }

    if (!this.state.canSignUpWithEmail) {
      this.handleCheckEmail();
      return false;
    }

    return true;
  };

  handleRequestOTP = async () => {
    const {email} = this.state;

    this.setState({isRequestingOTP: true, code: ''});

    try {
      await postSendCode({email});
      this.setState({showOtpModal: true});
    } catch (error) {
      console.log(
        '🚀 ~ file: SignUpScreen.js ~ line 206 ~ SignUpScreen ~ handleRequestOTP= ~ error',
        error,
      );
      alert(
        'There was an error in requesting One-Time password. Please try again',
      );
    }

    this.setState({isRequestingOTP: false});
  };

  handleShowOtpModal = () => {
    if (!this.isFormValid()) {
      return;
    }

    this.handleRequestOTP();
  };

  handleGoToNextPage = () => {
    const {navigation} = this.props;
    const {fullName, email, password1} = this.state;
    const studentData = {
      fullName: fullName,
      email_id: email.toLowerCase(),
      password: password1,
    };

    navigation.push(UN_AUTHENTICATED_ROUTES.studentDetails.path, {
      userData: studentData,
    });
  };

  render() {
    const {
      fullName,
      email,
      code,
      password1,
      password2,
      fieldsErrors,
      isCheckingEmail,
      canSignUpWithEmail,
      isRequestingOTP,
      fieldError,
      showOtpModal,
      loadingCheckOtp,
    } = this.state;

    return (
      <View style={styles.container}>
        <KeyboardAwareScrollView style={styles.keyboardContainer}>
          {isWebDesktop && (
            <Image
              source={starBanner}
              resizeMode="contain"
              style={styles.starImage}
            />
          )}
          {showOtpModal ? (
            <>
              <Text
                style={[
                  styles.signInLabel,
                  isWebDesktop ? styles.textCenter : undefined,
                ]}>
                {'Verify OTP'}
              </Text>

              <View style={styles.formContainer}>
                <Text style={styles.text} category="h6">
                  {
                    'A One Time Password (OTP) has been sent to your email. Please enter to verify your account.'
                  }
                </Text>
                <Input
                  keyboardType="phone-pad"
                  style={styles.input}
                  placeholder="Enter OTP"
                  value={code}
                  onChangeText={(val) => this.setState({code: val})}
                  status={fieldUtils.getFieldStatus(fieldError)}
                  caption={fieldUtils.getErrorText(fieldError)}
                  captionIcon={fieldUtils.getErrorIcon(fieldError)}
                  autoFocus
                />
                <AppButton
                  style={styles.btnLogin}
                  status="primary"
                  title="Verify"
                  appearance="filled"
                  size="large"
                  loading={loadingCheckOtp}
                  onPress={this.checkCode}
                />
                <AppButton
                  style={styles.btnLogin}
                  status="primary"
                  title="Cancel"
                  appearance="outline"
                  size="large"
                  onPress={() => this.setState({showOtpModal: false})}
                />
              </View>
            </>
          ) : (
            <>
              <Text
                style={[
                  styles.signInLabel,
                  isWebDesktop ? styles.textCenter : undefined,
                ]}>
                {'Sign Up'}
              </Text>

              <View style={styles.formContainer}>
                <Input
                  ref={(ref) => (this.fName = ref)}
                  style={styles.inputBox}
                  label="Student Full Name (as in IC)"
                  autoCompleteType="name"
                  value={fullName}
                  onChangeText={(text) => this.onChange('fullName', text)}
                  status={fieldUtils.getFieldStatus(fieldsErrors.fullName)}
                  caption={fieldUtils.getErrorText(fieldsErrors.fullName)}
                  captionIcon={fieldUtils.getErrorIcon(fieldsErrors.fullName)}
                />
                <Input
                  keyboardType="email-address"
                  style={styles.inputBox}
                  label="Email"
                  value={email}
                  autoCompleteType="email"
                  onChangeText={(text) => {
                    if (canSignUpWithEmail) {
                      this.setState({canSignUpWithEmail: false});
                    }
                    this.onChange('email', text);
                  }}
                  onBlur={this.handleCheckEmail}
                  accessoryRight={
                    isCheckingEmail ? LoadingIndicator : undefined
                  }
                  status={fieldUtils.getFieldStatus(fieldsErrors.email)}
                  caption={fieldUtils.getErrorText(fieldsErrors.email)}
                  captionIcon={fieldUtils.getErrorIcon(fieldsErrors.email)}
                />
                <Input
                  style={styles.inputBox}
                  label="Password"
                  autoCompleteType="password"
                  value={password1}
                  onChangeText={(text) => this.onChange('password1', text)}
                  status={fieldUtils.getFieldStatus(fieldsErrors.password1)}
                  caption={fieldUtils.getErrorText(fieldsErrors.password1)}
                  captionIcon={fieldUtils.getErrorIcon(fieldsErrors.password1)}
                />
                <Input
                  style={styles.inputBox}
                  label="Confirm Password"
                  value={password2}
                  onChangeText={(text) => this.onChange('password2', text)}
                  status={fieldUtils.getFieldStatus(fieldsErrors.password2)}
                  caption={fieldUtils.getErrorText(fieldsErrors.password2)}
                  captionIcon={fieldUtils.getErrorIcon(fieldsErrors.password2)}
                />
                <>
                  <View style={styles.termsAndPPContainer}>
                    <Text status="basic">
                      {'By click on next, you accept our'}
                    </Text>
                    <TouchableOpacity
                      onPress={() => {
                        const {navigation} = this.props;
                        navigation.push(
                          UN_AUTHENTICATED_ROUTES.termsOfServices.path,
                        );
                      }}>
                      <Text status="primary" style={styles.underlineText}>
                        {'Terms of services'}
                      </Text>
                    </TouchableOpacity>
                    <Text status="basic">{'&'}</Text>
                    <TouchableOpacity
                      onPress={() => {
                        const {navigation} = this.props;
                        navigation.push(
                          UN_AUTHENTICATED_ROUTES.privacyPolicy.path,
                        );
                      }}>
                      <Text status="primary" style={styles.underlineText}>
                        {'Privacy policy'}
                      </Text>
                    </TouchableOpacity>
                    <Text status="basic">{'.'}</Text>
                  </View>
                  <AppButton
                    onPress={this.handleShowOtpModal}
                    style={styles.btnLogin}
                    status="primary"
                    title="Next"
                    appearance="filled"
                    size="large"
                    loading={isRequestingOTP}
                  />
                  <View style={styles.signInContainer}>
                    <Text status="basic">{'Already have an account?'}</Text>
                    <TouchableOpacity onPress={this.onSignIn}>
                      <Text status="primary" style={styles.underlineText}>
                        {'Login'}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </>
              </View>
            </>
          )}
        </KeyboardAwareScrollView>
        {/* <OtpModal
          email={email}
          onClose={() => {
            this.setState({showOtpModal: false});
          }}
          onSuccess={this.handleGoToNextPage}
          visible={this.state.showOtpModal}
        /> */}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFF',
    flex: 1,
    paddingBottom: 24,
    paddingHorizontal: 16,
    alignItems: 'center',
  },
  keyboardContainer: {
    flex: 1,
  },
  textCenter: {textAlign: 'center'},
  tabContainer: {
    marginBottom: 5,
  },
  signInContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: px(16),
    paddingBottom: px(20),
  },
  socialAuthContainer: {
    marginTop: 48,
  },
  btnLogin: {
    marginTop: px(16),
  },
  formContainer: {
    backgroundColor: '#FFF',
    marginTop: 26,
    color: '#000',
    width: '100%',
  },
  inputBox: {
    marginBottom: 12,
  },
  helpLabel: {
    fontWeight: '500',
    paddingHorizontal: 20,
    fontSize: 16,
    marginBottom: 15,
  },
  signInLabel: {
    marginTop: 28,
    fontWeight: '700',
    fontSize: 24,
  },
  signUpButton: {
    flexDirection: 'row-reverse',
    paddingHorizontal: 0,
  },
  socialAuthButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  socialAuthHintText: {
    alignSelf: 'center',
    marginBottom: 16,
  },
  termsAndPPContainer: {
    flexDirection: 'row',
    marginTop: px(2),
    flexWrap: 'wrap',
  },
  underlineText: {
    marginHorizontal: px(5),
  },
  starImage: {
    justifyContent: 'center',
    alignSelf: 'center',
    width: wp(15),
    height: wp(15),
  },
  text: {
    marginTop: px(24),
    marginBottom: px(20),
    fontWeight: '400',
    fontSize: 16,
  },
});

export default SignUpScreen;
